import {PropsWithChildren} from "react";
import {OtsBadge, OtsBadgeSize, OtsBadgeTone} from "./OtsBadge";

export type StatusTone = OtsBadgeTone;

export const StatusPill = ({
  tone = "neutral",
  size = "default",
  ariaLabel,
  children
}: PropsWithChildren<{tone?: StatusTone; size?: OtsBadgeSize; ariaLabel?: string}>) => <OtsBadge tone={tone} size={size} ariaLabel={ariaLabel} dot>{children}</OtsBadge>;
